const subscribers = (state = [], action) => {
    switch (action.type) {
        case 'SET_SUBSCRIBERS': {
            return action.subscribers
        }
        case 'ADD_SUBSCRIBER':
        case 'REPLACE_SUBSCRIBER':
            if(action.subscriber) {
                const subscriber = Object.assign(state.filter(s => s.username === action.subscriber.username)[0] || {}, action.subscriber)
                return state.filter(s => s.username !== action.subscriber.username).concat(subscriber)
            }
        case 'REMOVE_SUBSCRIBER':
            return state.filter(s => s.username != action.subscriber.username) 
    }
    return state
}
export default subscribers



// WEBPACK FOOTER //
// ./reducers/subscribers.js